export default {
  title: "¿Cómo te gustaría participar en el ANTIPARTIDO?",
  subtitle: "Selecciona tu rol de participación. Podrás modificarlo más adelante desde tu perfil.",
  options: {
    representative: "Representante en algún distrito electoral o en algún Estado",
    notario: "NOTARIO ELECTORAL CIUDADANO en la casilla el día de la elección",
    none: "Ninguna de las anteriores",
  },
  infoModal: {
    title: "Roles de participación",
    representative: {
      title: "Representante",
      description:
        "Como Representante, podrás actuar como enlace entre el ANTIPARTIDO y los ciudadanos de tu distrito o Estado. Tu función es promover la participación ciudadana y representar los intereses de tu comunidad en los procesos electorales.",
    },
    notario: {
      title: "Notario Electoral Ciudadano",
      description:
        "Como Notario Electoral Ciudadano, participarás el día de la elección en las casillas electorales para verificar y dar fe del proceso. Tu presencia garantiza la transparencia y legitimidad de la jornada electoral.",
    },
    close: "Entendido",
  },
  save: "Guardar",
  saving: "Guardando...",
  error: "Error al guardar tu selección. Inténtalo de nuevo.",
  validation: "Debes seleccionar al menos una opción.",
  reviewer: {
    subtitle: "Cuenta de revisión: los roles de participación son fijos y no se pueden modificar.",
  },
}
